import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import Button from 'components/util/Button'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import styles from './_challenges.css'
import logo from 'images/landing/challenges/logo.png'

function Challenges () {
  return (
    <div className={styles.challengesWrapper}>
      <div className={styles.challenges}>
        <div className={styles.logoWrapper}>
          <div className={styles.logo}>
            <img src={logo} />
          </div>
        </div>
        <div className={styles.content}>
          <Title align="right" color="white">
            <FormattedHTMLMessage id='landingPage.challenges.title' defaultMessage='Take On New Challenges' />
          </Title>
          <Caption align="right">
            <FormattedMessage
              id='landingPage.challenges.caption'
              defaultMessage='Think you can complete 1,018KM in 2018? Join the community challenge and compete to win exclusive gear.'
            />
          </Caption>
          <Button
            className={styles.callToAction}
            size="medium"
            type="default"
            onClick={() => { window.location.href = '/challenges' } }
          >
            <FormattedMessage
              id='landingPage.challenges.callToAction'
              defaultMessage='View Challenges'
            />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Challenges



// WEBPACK FOOTER //
// ./src/components/landing/challenges/index.jsx